import {Address} from "@/interfaces/address"
import {ContactPerson} from "@/interfaces/contactperson"
import {CourseRegistration} from "@/interfaces/courseregistration"
import {InsuranceSubscription} from "@/interfaces/insurancesubscription"
import {MedicalCertificate} from "@/interfaces/medicalcertificate"
import {WorkshopAttendance} from "@/interfaces/workshopattendance"
import {Card} from "@/interfaces/card"
import {WorkshopRegistration} from "@/interfaces/workshopregistration"
import {Payment} from "@/interfaces/payment";
import {Teacher} from "@/interfaces/teacher";

export const genderOptions: string[] = ["M", "F", "O"]

export interface Student {
  "@id"?: string;
  id?: number;
  name?: string;
  firstname?: string;
  phone?: string;
  fatherPhone?: string;
  motherPhone?: string;
  email?: string | null;
  birthday?: string;
  pictureUrl?: string;
  comment?: string;
  medicalHistory?: string;
  gender?: string;
  address?: Address;
  keep?: boolean;
  landLinePhone?: string;
  email2?: string;
  imageRight?: boolean;
  validInsuranceSubscription?: boolean;
  registerValidated?: boolean;
  roles?: string[];
  password?: string;
  isRegisteredForGala?: boolean;
  galaClothingSize?: string;
  cards?: Card[];
  payments?: Payment[];
  insuranceSubscriptions?: InsuranceSubscription[];
  workShopAttendances?: WorkshopAttendance[];
  courseRegistrations?: CourseRegistration[];
  workshopRegistrations?: WorkshopRegistration[];
  medicalCertificates?: MedicalCertificate;
  contactPeople?: ContactPerson[];
  linkedTeacher?: Teacher | null;
  isCrew?: boolean;
  freeRegistrationQuotaOverride?: number | null;
}
